const CustomOperatorSelector = ({
  handleOnChange,
  options,
  value,
  fieldData,
}) => {
  const groupedOptions = options.reduce((acc, field) => {
    if (!acc[field.category]) acc[field.category] = [];
    acc[field.category].push(field);
    return acc;
  }, {});

  if (fieldData.category === "CustomerGroup") return "Count";

  return (
    <>
      <select
        className="form-control"
        value={value}
        onChange={(e) => {
          handleOnChange(e.target.value);
        }}
      >
        {Object.entries(groupedOptions).map(([category, fields]) =>
          fields?.map((field) => (
            <option key={field.name} value={field.name}>
              {field.label}
            </option>
          ))
        )}
      </select>
    </>
  );
};
export default CustomOperatorSelector;
